export const POLICY_VERSION = "2026-08-26.1" as const;
export const POLICY_EFFECTIVE_DATE = "2026-08-26" as const;
export const OPERATOR_NAME = "문옵스(MUNOPS)" as const;
export const SUPPORT_EMAIL = "support@munops.com" as const;
export const CANONICAL_ORIGIN = "https://sueopmachim.com" as const;
